export default __webpack_public_path__ + "static/media/shipshap-postman.7c1e0100.svg";